export const hasInvalidChars = (content) => {
  const invalidChars = /<|>|=|%|:|\[|\]/;
  return invalidChars.test(content);
};
